import React from 'react'
import { PaymentBlock } from './PaymentBlock'

class MyAccountPayment extends React.Component {
  render() {
    return <PaymentBlock {...this.props} />
  }
}

export { MyAccountPayment }

export default MyAccountPayment
